import { useCallback, useState } from 'react';

const usePagination = (defaultPageSize = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const onPageChange = useCallback(
    (page: number) => {
      setCurrentPage(page);
    },
    [setCurrentPage]
  );

  const onShowSizeChange = useCallback(
    (_: number, size: number) => {
      setPageSize(size);
    },
    [setPageSize]
  );

  const resetPagination = useCallback(() => {
    setCurrentPage(1);
    setPageSize(defaultPageSize);
  }, [defaultPageSize]);

  return {
    currentPage,
    pageSize,
    onPageChange,
    onShowSizeChange,
    resetPagination,
  };
};

export default usePagination;
